import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Mail from "@mui/icons-material/Mail";
import "../assets/styles/Footer.scss";

function Footer() {
  return (
    <footer>
      <h3>Contact Me</h3>
      <h5>Lets have a chat. Send me a message on LinkedIn or Mail</h5>
      <div>
        <a href="https://github.com/quamnana" target="_blank" rel="noreferrer">
          <GitHubIcon />
        </a>
        <a
          href="https://www.linkedin.com/in/nana-gyambrah-5736911a8/"
          target="_blank"
          rel="noreferrer"
        >
          <LinkedInIcon />
        </a>
        <a
          href="mailto:quamgyambrah@gmail.com"
          target="_blank"
          rel="noreferrer"
        >
          <Mail />
        </a>
      </div>
      <br />
      <br />
      <p>
        A portfolio designed & built by{" "}
        <a href="https://github.com/quamnana" target="_blank" rel="noreferrer">
          Nana Gyambrah
        </a>{" "}
        with 💜
      </p>
    </footer>
  );
}

export default Footer;
